import ebookImg from "../../../assets/EMP_GroceryInsightsFormSection/industry-embed-form-iframe-scroll.webp";

import React, { useState } from "react";

const InsightsFormSection = () => {
  const [isOverlayVisible, setIsOverlayVisible] = useState(true);

  const handleClick = () => {
    setIsOverlayVisible(false);
  };

  return (
    <section
      className="
        relative
        left-1/2
        right-1/2
        -ml-[50vw]
        -mr-[50vw]
        w-screen
        min-h-[90vh]
        overflow-hidden
        bg-gradient-to-br
        from-[#dfe6f7]
        via-[#f3f3f7]
        to-[#f7d9d5]
        flex
        items-center
      "
    >
      <div
        className="
          max-w-[1800px]
          mx-auto
          px-6
          lg:px-16
          py-6
          grid
          grid-cols-1
          lg:grid-cols-2
          gap-10
          items-center
        "
      >
        {/* ================= LEFT SIDE ================= */}
        <div className="relative flex justify-center -ml-[70px] lg:-mt-[70px]">
          
          {/* BACKGROUND LAYERS */}
          <div
            className="
              absolute
              top-0
              left-[30px]
              w-[520px]
              h-[420px]
              bg-[#f39c12]
              z-0
            "
          ></div>

          <div
            className="
              absolute
              top-[24px]
              left-[56px]
              w-[520px]
              h-[420px]
              bg-[#d567b5]
              z-0
            "
          ></div>

          {/* SCROLLABLE IMAGE BOX */}
          <div
            onClick={handleClick}
            className="
              relative
              z-10
              mt-[50px]
              left-[15px]
              w-full
              max-w-[520px]
              h-[420px]
              overflow-y-auto
              overflow-x-hidden
              bg-white
              shadow-xl
              scroll-box
            "
            style={{
              scrollbarWidth: "thin",
              scrollbarColor: "#001a57 transparent",
              WebkitOverflowScrolling: "touch",
            }}
          >
            {/* CUSTOM SCROLLBAR */}
            <style>
              {`
                .scroll-box::-webkit-scrollbar {
                  width: 4px;
                }

                .scroll-box::-webkit-scrollbar-track {
                  background: transparent;
                }

                .scroll-box::-webkit-scrollbar-thumb {
                  background: #001a57;
                  border-radius: 999px;
                }
              `}
            </style>

            {/* BLUE OVERLAY + BUTTON */}
            {isOverlayVisible && (
              <div
                className="
                  absolute
                  inset-0
                  bg-[#001a57]/50
                  flex
                  flex-col
                  items-center
                  justify-center
                  z-20
                  transition-all
                  duration-500
                "
              >
                {/* YELLOW ICON */}
                <div
                  className="
                    w-[44px]
                    h-[70px]
                    border-[4px]
                    border-[#ff5a00]
                    rounded-full
                    flex
                    justify-center
                    pt-3
                  "
                >
                  <div
                    className="
                      w-[12px]
                      h-[12px]
                      rounded-full
                      bg-[#ff5a00]
                      animate-bounce
                    "
                  ></div>
                </div>

                {/* TEXT */}
                <p
                  className="
                    mt-4
                    text-white
                    text-[22px]
                    font-semibold
                  "
                >
                  Click and scroll
                </p>
              </div>
            )}

            {/* IMAGE */}
            <img
              src={ebookImg}
              alt="ebook"
              className="
                w-full
                h-auto
                block
              "
            />
          </div>
        </div>

        {/* ================= RIGHT SIDE FORM ================= */}
        <div className="pt-2 max-w-[450px] w-full lg:ml-[140px] lg:mt-[60px]">
          
          {/* HEADING */}
          <h2
            className="
              text-[38px]
              sm:text-[46px]
              lg:text-[36px]
              leading-[1.08]
              text-[#240000]
              lg:font-[200]
            "
            style={{ fontFamily: "serif" }}
          >
            Get More
            <br />
            On-Demand Pay Insights.
          </h2>

          {/* FORM */}
          <form className="mt-6 lg:mt-10">
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              
              <div>
                <label className="block text-[14px] font-semibold mb-2 lg:mb-1">
                  First Name <span className="text-red-600">*</span>
                </label>

                <input
                  type="text"
                  className="
                    w-full
                    h-[46px]
                    border
                    border-gray-400
                    bg-white
                    px-4
                    text-[16px]
                    outline-none
                  "
                />
              </div>

              <div>
                <label className="block text-[14px] font-semibold mb-2 lg:mb-1">
                  Last Name <span className="text-red-600">*</span>
                </label>

                <input
                  type="text"
                  className="
                    w-full
                    h-[46px]
                    border
                    border-gray-400
                    bg-white
                    px-4
                    text-[16px]
                    outline-none
                  "
                />
              </div>
            </div>

            <div className="mt-4">
              <label className="block text-[14px] font-semibold mb-2 lg:mb-1">
                Work Email <span className="text-red-600">*</span>
              </label>

              <input
                type="email"
                className="
                  w-full
                  h-[46px]
                  border
                  border-gray-400
                  bg-white
                  px-4
                  text-[16px]
                  outline-none
                "
              />
            </div>

            <div className="mt-4">
              <label className="block text-[14px] font-semibold mb-2 lg:mb-1">
                Company Name <span className="text-red-600">*</span>
              </label>

              <input
                type="text"
                className="
                  w-full
                  h-[46px]
                  border
                  border-gray-400
                  bg-white
                  px-4
                  text-[16px]
                  outline-none
                "
              />
            </div>

            <div className="mt-4">
              <label className="block text-[14px] font-semibold mb-2 lg:mb-1">
                Number of Employees{" "}
                <span className="text-red-600">*</span>
              </label>

              <input
                type="text"
                className="
                  w-full
                  h-[46px]
                  border
                  border-gray-400
                  bg-white
                  px-4
                  text-[16px]
                  outline-none
                "
              />
            </div>

            <div className="mt-4">
              <label className="block text-[14px] font-semibold mb-2 lg:mb-1">
                Industry
              </label>

              <select
                className="
                  w-full
                  h-[46px]
                  border
                  border-gray-400
                  bg-white
                  px-4
                  text-[16px]
                  outline-none
                "
              >
                <option>Select...</option>
                <option>Retail</option>
                <option>Healthcare</option>
                <option>Technology</option>
              </select>
            </div>

            <button
              type="submit"
              className="
                mt-7
                bg-[#240000]
                text-white
                px-8
                py-2
                text-[18px]
                font-semibold
                hover:bg-[#3b0000]
                transition-all
                duration-300
              "
            >
              Submit
            </button>

            <p className="mt-5 text-[12px] text-gray-500 italic">
              This site is protected by reCAPTCHA.
            </p>
          </form>
        </div>
      </div>
    </section>
  );
};

export default InsightsFormSection;